import { INotes } from "~/utils/interface/jobDetails";
import styles from "./NoteTab.module.scss";
import classNames from "classnames/bind";
import { useSelector } from "react-redux";
import { RootState } from "~/redux/store";
import { useEffect } from "react";
import { useAppDispatch } from "~/redux/hooks";
import { handleGetUsers } from "~/thunks/userManagement/userManagementThunk";
import PrimaryButton from "~/components/common/primary-button/PrimaryButton";
import { PlusIcon } from "lucide-react";

const cx = classNames.bind(styles);

const isToday = (dateString?: string) => {
  if (!dateString) return false;
  const date = new Date(dateString);
  const today = new Date();
  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
};

const NoteTab = ({
  notes,
  onAddNote,
}: {
  notes: INotes[];
  onAddNote: () => void;
}) => {
  const dispatch = useAppDispatch();
  const { users } = useSelector((state: RootState) => state.userManagement);
  const formatTime = (date: string | undefined) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  useEffect(() => {
    dispatch(handleGetUsers());
  }, [dispatch]);

  const getUserById = (id: string) => {
    return users.find((user) => user.id.toString() === id);
  };

  const todayNotes = notes.filter((note) => isToday(note.createdAt));

  return (
    <div className={cx("note-tab-container")}>
      <div className={cx("note-body")}>
        {notes.map((note) => (
          <div className={cx("note-item")} key={note.id}>
            <div className={cx("note-item-header")}>
              <h3 className={cx("note-item-title")}>{note.title}</h3>
              <div
                className={cx(
                  "note-item-type",
                  note.type === "Private" ? "private" : "public"
                )}
              >
                {note.type}
              </div>
            </div>
            <p className={cx("note-item-content")}>{note.content}</p>
            <div className={cx("note-item-footer")}>
              <p className={cx("note-item-time")}>
                {getUserById(note?.createdBy?.toString() || "")?.name || "N/A"}
              </p>

              <p className={cx("note-item-time")}>
                {formatTime(note.createdAt)}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className={cx("footer")}>
        <PrimaryButton
          title="Add Note"
          icon={<PlusIcon className={cx("add-note-icon")} />}
          onClick={onAddNote}
          className={cx("add-note-button")}
        />
      </div>
    </div>
  );
};

export default NoteTab;
